// Zentrale Stelle zum Parsen der Story-JSON-Struktur, die vom Backend kommt (Felder wie titel,
// bericht, betmanTipp, imageUrl, quote_1/quote_X/quote_2, status, ...). Überall dort verwenden,
// wo eine Story geöffnet/angezeigt wird - verhindert, dass an einer Stelle sauber geparst wird
// und an einer anderen der rohe JSON-Text unverändert durchgereicht wird.

// Setzt bildBasisUrl vor einen relativen Bild-Pfad (z.B. "/spielbericht/images/xyz.png" ->
// "https://app.team-match.io/spielbericht/images/xyz.png") - lässt aber bereits vollständige
// URLs (http://... oder https://...) unangetastet, falls der Server die mal doch schon voll
// liefert. Ohne diese Auflösung versucht der Browser den relativen Pfad fälschlich gegen die
// HOST-Seite aufzulösen (statt gegen die eigentliche API-Domain) und findet dort nichts.
export function vollstaendigeBildUrl(pfad, basis) {
  if (!pfad) return pfad
  if (/^https?:\/\//i.test(pfad)) return pfad
  return `${basis}${pfad}`
}

// GEÄNDERT: zentrale Stelle für die zeigeTipp-Logik, statt an mehreren Orten (useSpielplanData.js,
// BetmanStoryWidget.vue) dieselbe Prüfung zu wiederholen - die bisherige Prüfung
// (status === 'preview') blieb bei neueren Phasen wie 'story'/'rumor' fälschlich immer false,
// obwohl auch dort ein Tipp sinnvoll gezeigt werden sollte. Jetzt: Tipp wird bei JEDER Phase
// AUSSER 'report' gezeigt - dort ist betman_tipp ja eine TIPP-AUSWERTUNG (Rückblick), kein neuer
// Tipp, und wird ohnehin anders benannt/dargestellt (siehe BetmanStoryBody.vue).
export function sollTippZeigen(status) {
  return status !== 'report'
}

/**
 * Parst das JSON im text-Feld (Story-Inhalt) und optional imageBetman (Bild-Metadaten, falls
 * getrennt vorhanden) zu EINEM flachen Objekt zusammengeführt. Löst dabei imageUrl/avatarUrl
 * (kommen vom Server nur relativ) auf vollständige URLs auf.
 *
 * @param {{ text: string, imageBetman?: string|null }} rohesStoryObjekt
 * @param {string} bildBasisUrl - Basis-URL für relative Bild-Pfade, Default die Haupt-API-Domain
 * @returns {object|null} das geparste, flache Objekt, oder null falls JSON.parse fehlschlägt
 */
export function parseStoryJson(rohesStoryObjekt, bildBasisUrl = 'https://app.team-match.io') {
  try {
    const storyDaten = JSON.parse(rohesStoryObjekt.text)
    const bildDaten = rohesStoryObjekt.imageBetman == null
      ? null
      : JSON.parse(rohesStoryObjekt.imageBetman)
    const zusammengefuehrt = { ...storyDaten, ...(bildDaten ?? {}) }

    return {
      ...zusammengefuehrt,
      imageUrl: vollstaendigeBildUrl(zusammengefuehrt.imageUrl, bildBasisUrl),
      avatarUrl: vollstaendigeBildUrl(zusammengefuehrt.avatarUrl, bildBasisUrl)
    }
  } catch {
    return null
  }
}

/**
 * Baut aus dem geparsten Story-Objekt ein einfaches, fertig formatiertes HTML - für Stellen, die
 * (wie das generische DetailOverlay) nur EIN HTML-Blob per v-html anzeigen, statt die Felder
 * einzeln in einem eigenen Layout zu verwenden (siehe BetmanStoryDetail.vue für Letzteres).
 *
 * @param {object|null} geparst - Ergebnis von parseStoryJson(...)
 * @param {string} fallbackRohtext - falls geparst null ist (Parse-Fehler), diesen Text zeigen
 */
export function formatiereStoryAlsHtml(geparst, fallbackRohtext = '') {
  if (!geparst) return fallbackRohtext

  const titel = geparst.titel ?? ''
  const bildUrl = geparst.imageUrl ?? ''
  const bericht = geparst.bericht ?? geparst.text ?? ''
  const zeigeTipp = sollTippZeigen(geparst.status)
  const tipp = zeigeTipp ? (geparst.betmanTipp ?? '') : ''

  return [
    bildUrl ? `<img src="${bildUrl}" alt="" style="width:100%;border-radius:8px;margin-bottom:0.75rem;" />` : '',
    titel ? `<h3 style="margin:0 0 0.5rem;">${titel}</h3>` : '',
    bericht ? `<div>${bericht}</div>` : '',
    tipp ? `<div style="margin-top:0.75rem;padding:0.6rem 0.8rem;background:var(--tm-accent-soft);border-radius:8px;font-weight:600;">🎙️ Bet-Man Tipp: ${tipp}</div>` : ''
  ].filter(Boolean).join('\n')
}